// extracted by mini-css-extract-plugin
export var text = "_9d-0";